import { SessionStatus } from '@/lib/types/session-status';

export const statusOptions = [
  {
    value: [SessionStatus.Booked],
    label: 'Booked',
    className: 'bg-success text-black',
  },
  {
    value: [SessionStatus.Completed],
    label: 'Completed',
    className: 'bg-success text-black',
  },
  {
    value: [SessionStatus.Skipped],
    label: 'Skipped',
    className: 'bg-danger text-black',
  },
  {
    value: [SessionStatus.Canceled],
    label: 'Canceled',
    className: 'bg-danger text-black',
  },
  {
    value: [],
    label: 'All',
    className: 'bg-gray-200 text-black',
  },
];
